// 付箋色の選好を localStorage に保存する。

const COLOR_KEY = "refinement-canvas:sticky:color";

export type StickyColor = "yellow" | "pink" | "blue" | "green";

const VALID_COLORS: readonly StickyColor[] = ["yellow", "pink", "blue", "green"];
const DEFAULT_COLOR: StickyColor = "yellow";

export const STICKY_COLOR_HEX: Record<StickyColor, string> = {
  yellow: "#fff5b3",
  pink: "#ffd6e7",
  blue: "#dbeafe",
  green: "#dcfce7",
};

export function loadStickyColor(): StickyColor {
  try {
    const value = window.localStorage.getItem(COLOR_KEY);
    return VALID_COLORS.find((c) => c === value) ?? DEFAULT_COLOR;
  } catch {
    return DEFAULT_COLOR;
  }
}

export function saveStickyColor(color: StickyColor): void {
  try {
    window.localStorage.setItem(COLOR_KEY, color);
  } catch {
    // localStorage が使えない環境では保存のみ諦める。
  }
}
